export * from './formapagamento-edit.component';
export * from './formapagamento-browse.component';